<template>
  <script type="application/ld+json">
    {{ structuredData }}
  </script>
</template>

<script>
/*
 * Based on https://developers.google.com/search/docs/data-types/product
 */
import { BRAND } from '@/config/constants'
import { BEST_REVIEW_RATING, WORST_REVIEW_RATING } from '@/stores/product'

const AVAILABILITY_OPTIONS = {
  0: 'OutOfStock',
  1: 'InStock',
}

export default {
  name: 'SeoProduct',

  props: {
    sku: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    images: {
      type: Array,
      required: true,
    },
    ratingValue: {
      type: Number,
      required: true,
    },
    ratingCount: {
      type: Number,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    currency: {
      type: String,
      required: true,
      validator(value) {
        return /^[A-Z]{3}$/.test(value)
      },
    },
    price: {
      type: Number,
      required: true,
    },
    inStock: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    structuredData() {
      const data = {
        '@context': 'https://schema.org/',
        '@type': 'Product',
        brand: BRAND,
        sku: this.sku,
        productID: this.sku, // More info: https://www.facebook.com/business/help/1175004275966513
        name: this.name,
        image: this.images,
        description: this.description,
        offers: {
          '@type': 'Offer',
          url: this.url,
          priceCurrency: this.currency,
          price: this.price,
          availability: `https://schema.org/${AVAILABILITY_OPTIONS[Number(this.inStock)]}`,
          itemCondition: 'https://schema.org/NewCondition',
          seller: {
            '@type': 'Organization',
            name: BRAND,
          },
        },
      }

      if (this.ratingCount > 0) {
        data.aggregateRating = {
          '@type': 'AggregateRating',
          ratingCount: this.ratingCount,
          ratingValue: this.ratingValue,
          bestRating: BEST_REVIEW_RATING,
          worstRating: WORST_REVIEW_RATING,
        }
      }

      return data
    },
  },
}
</script>
